module.exports = __webpack_public_path__ + "img/logo-pnb.3aae610b.png";